function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 20v-5H5l-3-4.5L5 6h5V4L9 3h6l-1 1v2h5l3 4.5-3 4.5h-5v5h1v1H9v-1h1zM7 9h10v1H7V9zm1 2h8v1H8v-1z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgLocationTrailhead = function SvgLocationTrailhead(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationTrailhead;